import React from "react";
import { PaymentSettings } from "../../../_metronic/layout/components/payment";
export const PaymentSettingsPage = () => {
  return <PaymentSettings />;
};
